import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WraV0Row} from "../models/wra-v0-row";
import {WraV0Header} from "../models/wra-v0-header";
import {of} from "rxjs";
import {WidgetRiskAssessmentV0Implemented} from "../../v0/models/widget-risk-assessment-v0-args.dto";
import {WidgetDialogService} from '../../../../services/widget-dialog.service';
import {IoniconsFilled} from "@pt/pt-models";
import { WraV0Threat } from '../models/wra-v0-threat';
import { ThreatKey } from 'it/primatoo/openapi/api/org/schemas/common/ThreatKey';
import { WraV0MeasureCategory } from '../models/wra-v0-measure-category';

@Component({
  selector: 'pt-wra-v0-editor',
  templateUrl: `wra-v0-editor.component.html`,
  styleUrls: [`wra-v0-editor.component.scss`],
})
export class WraV0EditorComponent {
  @Input() selectedGlobalMeasure: number;
  @Input() editable: boolean;
  @Input() rows: WraV0Row[] = [];
  @Input() header: WraV0Header;
  @Input() threats: WraV0Threat[];
  @Input() implementedValues: WidgetRiskAssessmentV0Implemented[];
  @Output() changedRow = new EventEmitter<WraV0Row>();

  IconRadiobutton = IoniconsFilled.radiobutton;
  IconRadioUnchecked = IoniconsFilled.radioUnchecked;

  constructor(private widgetDialogService: WidgetDialogService) {
  }

  openNote(row: WraV0Row) {
    const dialog = this.widgetDialogService.runTextArea(
      of(this.header.note),
      row?.widgetValue?.note,
      this.editable);
    dialog.subscribe((value) => {
      const changedRow: WraV0Row = JSON.parse(JSON.stringify(row));
      changedRow.widgetValue.note = value;
      this.changedRow.emit(changedRow);
    });
  }

  changedImplementedValue($event: WidgetRiskAssessmentV0Implemented, row: WraV0Row) {
    const copyRow: WraV0Row = JSON.parse(JSON.stringify(row));
    copyRow.widgetValue.implementedValue = $event.value
    this.changedRow.emit(copyRow);
  }

  classMeasureCategoryChecked(row: WraV0Row, t: WraV0Threat): string {
    const mc: WraV0MeasureCategory = row?.measureCategory;
    if (mc) {
      switch (t.uuid as ThreatKey) {
        case ThreatKey.ACCIDENTAL_OR_ILLEGAL_DESTRUCTION:
          return mc?.accidentalOrIllegalDestruction ? 'widget-icon-preview-color' : 'widget-icon-preview-color-disabled';
        case ThreatKey.LOSS:
          return mc.loss ? 'widget-icon-preview-color' : 'widget-icon-preview-color-disabled';
        case ThreatKey.IMPROPER_USE:
          return mc.improperUse ? 'widget-icon-preview-color' : 'widget-icon-preview-color-disabled';
        case ThreatKey.UNAUTHORIZED_ACCESS:
          return mc.unauthorizedAccess ? 'widget-icon-preview-color' : 'widget-icon-preview-color-disabled';
        case ThreatKey.UNAUTHORIZED_DISCLOSURE:
          return mc.unauthorizedDisclosure ? 'widget-icon-preview-color' : 'widget-icon-preview-color-disabled';
        case ThreatKey.UNAUTHORIZED_UPDATE:
          return mc.unauthorizedUpdate ? 'widget-icon-preview-color' : 'widget-icon-preview-color-disabled';
      }
    }
    return '';
  }

  iconMeasureCategoryChecked(row: WraV0Row, t: WraV0Threat): string {
    const mc: WraV0MeasureCategory = row?.measureCategory;
    if (mc) {
      switch (t.uuid as ThreatKey) {
        case ThreatKey.ACCIDENTAL_OR_ILLEGAL_DESTRUCTION:
          return mc?.accidentalOrIllegalDestruction ? this.IconRadiobutton : this.IconRadioUnchecked;
        case ThreatKey.LOSS:
          return mc.loss ? this.IconRadiobutton : this.IconRadioUnchecked;
        case ThreatKey.IMPROPER_USE:
          return mc.improperUse ? this.IconRadiobutton : this.IconRadioUnchecked;
        case ThreatKey.UNAUTHORIZED_ACCESS:
          return mc.unauthorizedAccess ? this.IconRadiobutton : this.IconRadioUnchecked;
        case ThreatKey.UNAUTHORIZED_DISCLOSURE:
          return mc.unauthorizedDisclosure ? this.IconRadiobutton : this.IconRadioUnchecked;
        case ThreatKey.UNAUTHORIZED_UPDATE:
          return mc.unauthorizedUpdate ? this.IconRadiobutton : this.IconRadioUnchecked;
      }
    }
    return '';
  }
}
